/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetProjectMetricsSummaryPayload,
  GetProjectMetricsSummaryPayload$Outbound,
  GetProjectMetricsSummaryPayload$outboundSchema,
} from "../components/getprojectmetricssummarypayload.js";

export type ListAttributeKeysSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListAttributeKeysSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListAttributeKeysSecurity = {
  option1?: ListAttributeKeysSecurityOption1 | undefined;
  option2?: ListAttributeKeysSecurityOption2 | undefined;
};

export type ListAttributeKeysRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getProjectMetricsSummaryPayload: GetProjectMetricsSummaryPayload;
};

/** @internal */
export type ListAttributeKeysSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListAttributeKeysSecurityOption1$outboundSchema: z.ZodMiniType<
  ListAttributeKeysSecurityOption1$Outbound,
  ListAttributeKeysSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listAttributeKeysSecurityOption1ToJSON(
  listAttributeKeysSecurityOption1: ListAttributeKeysSecurityOption1,
): string {
  return JSON.stringify(
    ListAttributeKeysSecurityOption1$outboundSchema.parse(
      listAttributeKeysSecurityOption1,
    ),
  );
}

/** @internal */
export type ListAttributeKeysSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListAttributeKeysSecurityOption2$outboundSchema: z.ZodMiniType<
  ListAttributeKeysSecurityOption2$Outbound,
  ListAttributeKeysSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAttributeKeysSecurityOption2ToJSON(
  listAttributeKeysSecurityOption2: ListAttributeKeysSecurityOption2,
): string {
  return JSON.stringify(
    ListAttributeKeysSecurityOption2$outboundSchema.parse(
      listAttributeKeysSecurityOption2,
    ),
  );
}

/** @internal */
export type ListAttributeKeysSecurity$Outbound = {
  Option1?: ListAttributeKeysSecurityOption1$Outbound | undefined;
  Option2?: ListAttributeKeysSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListAttributeKeysSecurity$outboundSchema: z.ZodMiniType<
  ListAttributeKeysSecurity$Outbound,
  ListAttributeKeysSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListAttributeKeysSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListAttributeKeysSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listAttributeKeysSecurityToJSON(
  listAttributeKeysSecurity: ListAttributeKeysSecurity,
): string {
  return JSON.stringify(
    ListAttributeKeysSecurity$outboundSchema.parse(listAttributeKeysSecurity),
  );
}

/** @internal */
export type ListAttributeKeysRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetProjectMetricsSummaryPayload: GetProjectMetricsSummaryPayload$Outbound;
};

/** @internal */
export const ListAttributeKeysRequest$outboundSchema: z.ZodMiniType<
  ListAttributeKeysRequest$Outbound,
  ListAttributeKeysRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getProjectMetricsSummaryPayload:
      GetProjectMetricsSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getProjectMetricsSummaryPayload: "GetProjectMetricsSummaryPayload",
    });
  }),
);

export function listAttributeKeysRequestToJSON(
  listAttributeKeysRequest: ListAttributeKeysRequest,
): string {
  return JSON.stringify(
    ListAttributeKeysRequest$outboundSchema.parse(listAttributeKeysRequest),
  );
}
